import {PropsWithChildren} from 'react';
import ReactDOM from 'react-dom';
import ScrollLock from 'react-scrolllock';

import cn from 'classnames';

import s from './Modal.module.css';

interface Props {
  idModalWrapper?: string;
  className?: string;
}

export function Modal({children, idModalWrapper, className}: PropsWithChildren<Props>): JSX.Element {
  const container = document.getElementById(idModalWrapper || '');

  return ReactDOM.createPortal(
    <>
      <ScrollLock isActive={true} />
      <div className={cn(s.root, className)}>{children}</div>
    </>,
    container ? container : document.body,
  );
}
